import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class MetaTranslationResolver implements Resolve<{ title?: string, description?: string }> {
    constructor(@Inject(TranslateService) private translateService: TranslateService) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{ title?: string, description?: string }> {
        let translationKey = '';
        let descriptionKey = '';
        if (route.data && route.data.title) {
            translationKey = route.data.title;
        }

        if (route.data && route.data.description) {
            descriptionKey = route.data.description;
        }

        let ret = {
            title: (await this.translateService.get(translationKey).toPromise()),
            description: (await this.translateService.get(descriptionKey).toPromise())
        };
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/utils/MetaTranslationResolver.ts